
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";

const TermsPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      
      <main className="flex-grow container mx-auto px-4 py-12 max-w-4xl">
        <div className="prose prose-sm sm:prose lg:prose-lg mx-auto dark:prose-invert">
          <h1 className="text-4xl font-bold mb-8 text-center">Terms of Service</h1>
          
          <div className="mb-8">
            <p className="text-muted-foreground mb-4">
              Welcome to PromptHub. By accessing or using our website, you agree to be bound by these 
              Terms of Service. Please read them carefully.
            </p>
          </div>
          
          <div className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Use of Service</h2>
            <p className="text-muted-foreground mb-4">
              You agree to use PromptHub only for lawful purposes and in a way that does not infringe upon 
              the rights of others or inhibit their use of the service.
            </p>
          </div>
          
          <div className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">User Content</h2>
            <p className="text-muted-foreground mb-4">
              When you submit prompts or other content to our platform, you grant us a non-exclusive, 
              worldwide, royalty-free license to use, store, and display that content.
            </p>
          </div>
          
          <div className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Intellectual Property</h2>
            <p className="text-muted-foreground mb-4">
              The PromptHub service and its original content, features, and functionality are owned by 
              PromptHub and are protected by international copyright, trademark, patent, trade secret, 
              and other intellectual property laws.
            </p>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default TermsPage;
